import { TrashIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import React, { FC } from 'react'
import styled from 'styled-components'
import { KVAnnotation, KVInspectionArea, RolodexEntryPatchJson } from 'types'

const StyledTrashIcon = styled(TrashIcon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const DeleteInspectionAreaButton: FC<{
  inspectionAreaId: string
}> = ({ inspectionAreaId }) => {
  const {
    sendKVCommand,
    selectedMarkup,
    setSelectedMarkup,
    annotations,
    inspectionAreas,
    setInspectionAreas,
    kestrelModel,
    setAnnotations,
  } = useKestrel()

  const { rolodexPatch } = useRolodexEdit()

  const deleteInspectionArea = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (sendKVCommand) {
      // Deletion of inspection area handled in inspectionAreaDeletionResponse
      if (selectedMarkup?.id === inspectionAreaId) setSelectedMarkup(undefined)

      sendKVCommand({
        command: KestrelCommands.DELETE_INSPECTION_AREA,
        inspectionAreaId: inspectionAreaId,
      })
    }

    const data: Record<string, unknown> = {}

    let updatedAnnotations = annotations ? [...annotations] : undefined
    if (updatedAnnotations) {
      updatedAnnotations = updatedAnnotations.map((annotation) => {
        if (
          annotation.tags['inspectionArea'] &&
          annotation.tags['inspectionArea'].value === inspectionAreaId
        ) {
          delete annotation.tags['inspectionArea']
        }

        return annotation
      })

      data['annotations'] = updatedAnnotations.map((a) =>
        KVAnnotation.toJSON(a)
      )
      setAnnotations(updatedAnnotations)
    }

    if (inspectionAreas) {
      const filteredInspectionAreas = inspectionAreas.filter(
        (a) => a.id !== inspectionAreaId
      )
      data['inspectionAreas'] = filteredInspectionAreas.map((area) =>
        KVInspectionArea.toJSON(area)
      )
      setInspectionAreas(filteredInspectionAreas)
    }

    if (kestrelModel?.id) {
      // Persist to rolodex
      const patchData: RolodexEntryPatchJson = {
        id: kestrelModel.id ?? '',
        data,
      }
      rolodexPatch([patchData])
    }
  }

  return (
    <TooltipWrapper label='Delete inspection area' side='top'>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={(e) => deleteInspectionArea(e)}>
        <StyledTrashIcon width={22} height={22} />
      </div>
    </TooltipWrapper>
  )
}
